import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';
import { FeatureFlagMap, FeatureFlagState, FeatureFlagsEnum } from './types';
import { GetFeatureFlags } from '@/connection/feature-flags';

export const reducers = (create: ReducerCreators<FeatureFlagState>) => ({
  loadFeatureFlags: create.asyncThunk(
    async () => {
      return GetFeatureFlags();
    },
    {
      fulfilled: (state, action) => {
        state.featureFlags = action.payload;
        state.loading = false;
      },
    }
  ),
  setFeatureFlags: create.reducer((state, action: PayloadAction<FeatureFlagMap>) => {
    state.featureFlags = action.payload;
  }),
  toggleFeatureFlag: create.reducer((state, action: PayloadAction<FeatureFlagsEnum>) => {
    state.featureFlags[action.payload] = !state.featureFlags[action.payload];
  }),
});
